var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFill2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 124,
    viewBox: "0 0 111 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7689 44.1812C38.6659 43.7615 39.6031 43.6637 40.48 43.8219C42.3459 44.164 43.9214 45.6791 44.1485 47.7606C43.5016 47.0419 42.6679 46.5962 41.7766 46.4324C40.871 46.2714 39.905 46.395 39.0051 46.8147C37.2169 47.6542 36.1675 49.4396 36.4493 51.3687C34.3103 49.1636 34.9744 45.4922 37.7689 44.1812V44.1812ZM40.5433 70.7664C42.389 71.787 48.1591 74.5844 54.2455 81.125L69 74.2049C66.4815 68.8401 68.0225 65.6863 65.527 60.3589C63.8192 56.7191 62.5169 56.4259 60.0444 56.4316L60.9241 58.3061C61.456 59.436 59.7396 60.2324 59.2164 59.1054L58.4344 57.4293C57.7933 56.0694 55.9878 56.515 54.3921 56.5869L55.4616 58.8639C55.9906 59.9909 54.2886 60.793 53.7539 59.6603L52.8281 57.688C52.1755 56.2936 50.301 56.8025 48.691 56.9089L49.8209 59.321C50.3528 60.4538 48.6421 61.2444 48.1189 60.1203L43.5275 50.3596C42.1073 47.3236 37.3951 49.4051 38.87 52.5417L45.6291 66.9742C44.7178 66.4366 43.0646 65.7897 41.9434 65.5856C38.4761 64.9589 36.455 68.5095 40.5433 70.7664V70.7664ZM20.125 32.25H25.875V26.5H20.125V32.25ZM48.875 40.875H60.375V35.125H48.875V40.875ZM54.625 32.25H60.375V26.5H54.625V32.25ZM23 40.875H28.75V35.125H23V40.875ZM8.625 26.5V32.25H17.25V26.5H8.625ZM29.6039 46.4007C29.7764 45.4635 30.1185 44.5866 30.5325 43.75H20.125V49.5H29.5723C29.4429 48.4765 29.4141 47.4386 29.6039 46.4007ZM8.625 40.875H20.125V35.125H8.625V40.875ZM28.75 32.25H34.5V26.5H28.75V32.25ZM46 32.25H51.75V26.5H46V32.25ZM32.3207 55.3707C31.4726 54.4967 30.866 53.4617 30.383 52.375H5.75V23.625H63.25V51.0237C65.6219 51.57 67.4619 52.8264 69 54.951V17.875H0V58.125H34.9888L32.3207 55.3707V55.3707ZM31.625 40.875H37.375V35.125H31.625V40.875ZM40.25 40.875H46V35.125H40.25V40.875ZM37.375 32.25H43.125V26.5H37.375V32.25Z",
    fill: "#3A89FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_736_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.232 60C80.232 60 84.798 36 70.227 36H45V108H105V69C105 58.743 89.259 57.765 80.232 60ZM93 93H57V90H93V93ZM93 84H57V81H93V84ZM93 75H57V72H93V75ZM82.704 36.225C89.31 39.747 100.518 50.874 105 56.868C101.142 54.168 92.868 51.897 86.727 53.331C87.393 48.927 86.172 39.729 82.704 36.225Z",
    fill: "url(#paint0_radial_736_16)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_736_16",
    x: 3,
    y: -6,
    width: 144,
    height: 156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 21
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_736_16"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_736_16",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_736_16",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5397 38.1421) rotate(49.2811) scale(89.7368 141.996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFill2);
export default __webpack_public_path__ + "static/media/fill2.d3bb0fa27abc6f9617a4988cd3de29b0.svg";
export { ForwardRef as ReactComponent };